import HeadTittle from '../../../components/HeadTittle';
import routes from '../../../Routes/routes';
import ButtonAction from '../../../components/buttons/ButtonAction';
import { CleanIcon, EditIcon } from '../../../components/buttons/IconButtons';
import DivContainerBody from '../../../components/DivContainerBody';
import { permissionObj } from '../../../Helpers/permission';
import UserRestrictionApp from './Functionality/UserRestrictionApp';
import Employees from './Subcomponents/Employees';
import Suppliers from './Subcomponents/Suppliers';
import Contractors from './Subcomponents/Contractors';
import Visitors from './Subcomponents/Visitors';
import ButtonIcon from '../../../components/buttons/ButtonIcon';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */

const UserRestriction = () => {
    const {
        t,
        DEV,
        contractorId,
        supplierId,
        permission,
        navigate,
        clearAllCheck,
        handelUpdate,
        extraDataSupplier,
        setExtraDataSupplier,
        extraDataContractor,
        setExtraDataContractor,
        extraDataEmployee,
        setExtraDataEmployee,
        sendEmailWhenCreateContractor,
        setSendEmailWhenCreateContractor,
        sendEmailWhenCreateEmployee,
        setSendEmailWhenCreateEmployee,
        sendEmailWhenCreateSupplier,
        setSendEmailWhenCreateSupplier,
        sendEmailWhenUpdateContractor,
        setSendEmailWhenUpdateContractor,
        sendEmailWhenUpdateEmployee,
        setSendEmailWhenUpdateEmployee,
        sendEmailWhenUpdateSupplier,
        setSendEmailWhenUpdateSupplier,
        livenessEmployee,
        setLivenessEmployee,
        validationEmployee,
        setValidationEmployee,
        biometricEmployee,
        setBiometricEmployee,
        livenessContractor,
        setLivenessContractor,
        validationContractor,
        setValidationContractor,
        biometricContractor,
        setBiometricContractor,
        livenessSupplier,
        setLivenessSupplier,
        validationSupplier,
        setValidationSupplier,
        biometricSupplier,
        setBiometricSupplier,
        livenessVisitor,
        setLivenessVisitor,
        validationVisitor,
        setValidationVisitor,
        biometricVisitor,
        setBiometricVisitor,
    } = UserRestrictionApp();

    if (contractorId !== null || supplierId !== null) navigate(routes.forbidden);
    else if (!DEV && !permission?.includes(permissionObj?.WEB_USER_RESTRICTION_UPDATE)) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                name={'user_restriction'}
                link={routes.employee.list}
                divStack={
                        <ButtonIcon
                            id='btn_ur_clean'
                            Icon={CleanIcon}
                            onClick={ clearAllCheck}
                            title={'clear_instances'}
                            className={'btn-clean-secondary-600'}
                            tooltipPlacement={'right'}
                            iconProps={'btn-icon-svg-12px icon-color-general-00'}
                        />
                }
            >
                <ButtonAction
                    id='btn_ur_update'
                    name={'update'}
                    className={'btn-icon-edit'}
                    Icon={EditIcon}
                    onClick={() => {
                        handelUpdate();
                    }}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className='row'>
                    <Employees
                        t={t}
                        extraDataEmployee={extraDataEmployee}
                        setExtraDataEmployee={setExtraDataEmployee}
                        sendEmailWhenCreateEmployee={sendEmailWhenCreateEmployee}
                        setSendEmailWhenCreateEmployee={setSendEmailWhenCreateEmployee}
                        sendEmailWhenUpdateEmployee={sendEmailWhenUpdateEmployee}
                        setSendEmailWhenUpdateEmployee={setSendEmailWhenUpdateEmployee}
                        validationEmployee={validationEmployee}
                        livenessEmployee={livenessEmployee}
                        biometricEmployee={biometricEmployee}
                        setValidationEmployee={setValidationEmployee}
                        setLivenessEmployee={setLivenessEmployee}
                        setBiometricEmployee={setBiometricEmployee}
                    />
                    <Suppliers
                        t={t}
                        extraDataSupplier={extraDataSupplier}
                        setExtraDataSupplier={setExtraDataSupplier}
                        sendEmailWhenCreateSupplier={sendEmailWhenCreateSupplier}
                        setSendEmailWhenCreateSupplier={setSendEmailWhenCreateSupplier}
                        sendEmailWhenUpdateSupplier={sendEmailWhenUpdateSupplier}
                        setSendEmailWhenUpdateSupplier={setSendEmailWhenUpdateSupplier}
                        validationSupplier={validationSupplier}
                        livenessSupplier={livenessSupplier}
                        biometricSupplier={biometricSupplier}
                        setValidationSupplier={setValidationSupplier}
                        setLivenessSupplier={setLivenessSupplier}
                        setBiometricSupplier={setBiometricSupplier}
                    />
                    <Contractors
                        t={t}
                        extraDataContractor={extraDataContractor}
                        setExtraDataContractor={setExtraDataContractor}
                        sendEmailWhenCreateContractor={sendEmailWhenCreateContractor}
                        setSendEmailWhenCreateContractor={setSendEmailWhenCreateContractor}
                        sendEmailWhenUpdateContractor={sendEmailWhenUpdateContractor}
                        setSendEmailWhenUpdateContractor={setSendEmailWhenUpdateContractor}
                        validationContractor={validationContractor}
                        livenessContractor={livenessContractor}
                        biometricContractor={biometricContractor}
                        setValidationContractor={setValidationContractor}
                        setLivenessContractor={setLivenessContractor}
                        setBiometricContractor={setBiometricContractor}
                    />
                    <Visitors
                        t={t}
                        validationVisitor={validationVisitor}
                        livenessVisitor={livenessVisitor}
                        biometricVisitor={biometricVisitor}
                        setValidationVisitor={setValidationVisitor}
                        setLivenessVisitor={setLivenessVisitor}
                        setBiometricVisitor={setBiometricVisitor}
                    />
                </div>
            </DivContainerBody>
        </>
    );
};

export default UserRestriction;
